export default "__VITE_ASSET__969392bf__"